const DECIMAL_REGEX = /^\d+(\.\d{1,2})?$/;

const validateDecimalValue = (value: string): boolean => {
  const isValid = DECIMAL_REGEX.test(value);

  return isValid;
};

export default validateDecimalValue;
